import { Routes, Route } from 'react-router-dom'
import LandingPage from './pages/LandingPage'
import PricingPage from './pages/PricingPage'
import ConfigurePage from './pages/ConfigurePage'
import PreviewPage from './pages/PreviewPage'
import CheckoutPage from './pages/CheckoutPage'
import SuccessPage from './pages/SuccessPage'
import { RequestAccessPage } from './pages/settings/RequestAccessPage'
import { VerifyTokenPage } from './pages/settings/VerifyTokenPage'
import { CustomerDashboardPage } from './pages/settings/CustomerDashboardPage'

function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/configure" element={<ConfigurePage />} />
      <Route path="/preview" element={<PreviewPage />} />
      <Route path="/checkout" element={<CheckoutPage />} />
      <Route path="/success" element={<SuccessPage />} />
      <Route path="/settings" element={<RequestAccessPage />} />
      <Route path="/settings/auth/verify" element={<VerifyTokenPage />} />
      <Route path="/settings/manage" element={<CustomerDashboardPage />} />
    </Routes>
  )
}

export default App
